/**
 * @chordbookpro/api-client
 *
 * Axios client factory, endpoint methods, shared TanStack Query keys and API
 * error normalization. Consumed by both the web and mobile clients.
 *
 * This package holds no secrets: authentication is injected by the host app
 * as a `getAuthToken` callback, and no Firebase or billing SDK is imported.
 */

export * from './client.js';
export * from './endpoints.js';
export * from './errors.js';
export * from './queryKeys.js';

import { createApiClient } from './client.js';
import { createEndpoints } from './endpoints.js';

/**
 * Convenience factory returning both the raw Axios instance and the endpoint
 * surface bound to it.
 *
 * @example
 * const { api } = createChordBookProApi({
 *   baseURL: config.apiUrl,
 *   getAuthToken: () => auth.currentUser?.getIdToken(),
 * });
 * const status = await api.billing.status();
 */
export function createChordBookProApi(options) {
  const http = createApiClient(options);
  return { http, api: createEndpoints(http) };
}
